import { render, staticRenderFns } from "./numList.vue?vue&type=template&id=e89f2644&scoped=true&"
import script from "./numList.vue?vue&type=script&lang=js&"
export * from "./numList.vue?vue&type=script&lang=js&"
import style0 from "./numList.vue?vue&type=style&index=0&id=e89f2644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89f2644",
  null
  
)

export default component.exports